"server-only";

import React from "react";
import classNames from "classnames";

const cssIcons = new Set(["loading"]);

const Icon = ({
  icon = "",
  className = "",
  style = {},
  fill = "currentColor",
  stroke = undefined,
  strokeWidth = undefined,
  ...rest
}) => {
  const normalizedClassName = classNames(
    "icon",
    `icon--${icon.replace(" ", "-")}`,
    className,
  );

  if (cssIcons.has(icon)) return <span className={normalizedClassName} />;

  try {
    const Component = require(
      `../../../../public/portal/img/icons/${icon}.svg?inline`,
    ).default;
    return (
      <span className={normalizedClassName}>
        <Component {...rest} style={{ fill, stroke, strokeWidth, ...style }} />
      </span>
    );
  } catch (e) {
    console.warn(`Icon "${icon}" not found. Maybe add it to cssIcons?`, e);
  }
};

export default Icon;
